<style lang="scss">
@import './index.scss';
</style>
<template>
    <div class='funnel-charts'>
        <div class="funnel-charts-title">
            <h1 class="funnel-charts-title-h3"><router-link :to="linkUrl">{{ $t('funnel.title') }}</router-link> > {{ funnelName }}</h1>
        </div>
        <div class="funnel-charts-view textEllipsis">
            <div class="funnel-charts-view-top">
                <div class="funnel-charts-view-top-div" span="3">
                    <p>{{ rate }}</p>
                    <h4>{{ $t('funnel.rate') }}</h4>
                </div>
                <div class="funnel-charts-view-top-div" span="5">
                    <p>{{ number | numberSeparator }}</p>
                    <h4>{{ $t('funnel.number') }}</h4>
                </div>
                <div class="funnel-charts-view-top-div" span="5">
                    <p>{{ achieve | numberSeparator }}</p>
                    <h4>{{ $t('funnel.achieve') }}</h4>
                </div>
                <div class="funnel-charts-view-top-div" span="5">
                    <p>{{ noAchieve | numberSeparator }}</p>
                    <h4>{{ $t('funnel.noAchieve') }}</h4>
                </div>
                <div class="funnel-charts-view-top-div" span="6">
                    <p class="textEllipsis" style="max-width:300px" :title="lowRate">
                      <span v-if="stepNumber !== '-'">{{ $t('funnel.targetStep.name') }}</span>{{stepNumber}}<span v-if="stepNumber !== '-'">{{$t('funnel.targetStep.name2')}}{{$t('funnel.targetStep.colon')}}</span>{{ lowRate }}
                    </p>
                    <h4>{{ $t('funnel.lowRate') }}</h4>
                </div>
            </div>
            <div class="funnel-charts-view-title">
              <Row>
                <i-col span="12" class="funnel-charts-view-title-h3">{{ $t('funnel.details') }}</i-col>
                <i-col span="12" class="funnel-charts-view-title-download">
                    <span class="iconfont icon-download tm-icon-font hover-style" @click="toExportTable"></span>
                </i-col>
              </Row>
            </div>
            <div class="funnel-charts-view-chart">
                <chart-move ref="funnelchart"></chart-move>
            </div>
        </div>
    </div>
</template>
<script>
import safeHtml from '../../filters/html-formate';
import numberSeparator from '../../filters/number-separator';
import percent from '../../filters/percent-formate';
import chartMove from '../../components/funnel-overview/chart-move';
import tableMove from '../../components/app-overview/table-move';
import $ from '../../libs/util';
import bus from '../../libs/bus';
import ln from '../../libs/locale';

export default {
  props: {},
  data() {
    return {
      funnelName: '',
      linkUrl: `/analytics/behavior/funnel/${bus.productInfo.productid}`,
      rate: '--',
      number: '--',
      achieve: '--',
      noAchieve: '--',
      stepNumber: '-',
      lowRate: '-',
      idList: [],
    };
  },
  components: {
    chartMove,
    tableMove,
  },
  filters: {
    numberSeparator,
    percent,
  },
  mounted() {
    const self = this;
    bus.$on('on-app-change', () => {
      self.$router.push({
        path: `/analytics/behavior/funnel/${bus.productInfo.productid}`,
      });
    });
    bus.$on('on-platform-change', () => {
      self.clearData();
      self.init();
    });
    bus.$on('on-conditions-change', () => {
      self.clearData();
      self.init();
    });
    bus.$on('on-date-change', () => {
      self.clearData();
      self.init();
    });
    bus.$on('on-change-lang', this.setColumn);
    if (!bus.productInfo.productid) {
      return;
    }
    this.init();
  },
  beforeDestroy() {
    bus.$off('on-app-change');
    bus.$off('on-platform-change');
    bus.$off('on-conditions-change');
    bus.$off('on-date-change');
    bus.$off('on-change-lang', this.setColumn);
    bus.funnelChart = undefined;
    this.funnelName = '';
  },
  methods: {
    init() {
      const self = this;
      Object.keys(self.$refs).forEach((i) => {
        self.$refs[i].clearData();
      });
      if (bus.funnelChart) {
        self.funnelName = bus.funnelChart.name;
        self.idList = self.reloadId(); // get the all eventid list
      }
      self.setData();
    },
    // 清除数据
    clearData() {
      this.rate = '--';
      this.number = '--';
      this.achieve = '--';
      this.noAchieve = '--';
      this.stepNumber = '-';
      this.lowRate = '-';
    },
    // 请求数据, 支持标准事件
    getData(idlist) {
      const start = bus.selectedDate[0];
      const end = bus.selectedDate[1];
      const conditions = bus.conditions;
      const params = {
        developerId: bus.developerid,
        productId: bus.productInfo.productid,
        platformIds: bus.platform,
        versions: conditions.version.length === 0 ? undefined : conditions.version,
        partnerIds: conditions.partner.length === 0 ? undefined : conditions.partner,
        userGroupList: conditions.newUserGroup.length === 0 ? undefined : conditions.newUserGroup,
        startTime: `${start.slice(2, 4)}${start.slice(5, 7)}${start.slice(8, 10)}`, // yyMMdd
        endTime: `${end.slice(2, 4)}${end.slice(5, 7)}${end.slice(8, 10)}`, // yyMMdd
        eventFlowInfo: idlist,
      };
      return $.ajax.post('app/rest/eventFlow.json/query', params);
    },
    setColumn() {
      const name = ln[bus.lang].funnel;
      const columns = [
        {
          title: name.step,
          type: 'index',
          width: 50,
        },
        {
          title: name.stepname,
          key: 'name',
          render(h, params) {
            return h('p', {
              class: {
                textEllipsis: true,
              },
              attrs: {
                title: safeHtml(params.row.name),
              },
            }, [
              safeHtml(params.row.name),
            ]);
          },
        },
        {
          title: name.eventuser,
          key: 'eventuser',
          align: 'right',
          width: 100,
        },
        {
          title: name.preRate,
          key: 'preRate',
          align: 'right',
          render(h, params) {
            const rate = params.row.preRate === '' ? '' : `${params.row.preRate}%`;
            return [`${rate}`];
          },
        },
        {
          title: name.rate,
          key: 'rate',
          align: 'right',
          render(h, params) {
            const rate = params.row.rate === '' ? '' : `${params.row.rate}%`;
            return [`${rate}`];
          },
        },
      ];
      this.$refs.funnelchart.tableColumn = columns;
    },
    // 展示Top数据,支持标准事件
    setData() {
      // 总人数和达成目标人数
      this.setColumn();
      // 发送http请求，获取漏斗转化数据
      this.getData(this.idList).then((res) => {
        const result = res;
        const oneUser = result[0].value;
        const endUser = result[result.length - 1].value;
        const rate = percent((endUser / oneUser) * 100, true);
        this.rate = rate === 'N/A' ? '0.00%' : rate;
        this.number = oneUser;
        this.achieve = endUser;
        this.noAchieve = oneUser - endUser;
        // 绘制图表，传递返回的参数
        this.drawChart(result);
      });
    },
    drawChart(total) {
      const chartData = { // data for chart
        name: [],
        series: [],
      };
      const tableData = []; // data for table
      // 初始化chart和table值，设置step名称
      bus.funnelChart.info.forEach((eachstep) => {
        // 如果stepname值存在，则取之；不存在就取eventid
        const currentStep = eachstep.stepname || eachstep.eventid;
        chartData.name.push(currentStep);
        tableData.push({
          name: currentStep,
        });
      });
      // 遍历所有的step，求每个step的rate值，并赋值给setData和tabledata
      const baseValue = total[0].value; // 第一步的用户数量
      const setData = []; // 图表数据
      for (let i = 0; i < total.length; i += 1) {
        const currentRate = percent((total[i].value / baseValue) * 100);
        setData[i] = currentRate === 'N/A' ? '0.00' : currentRate;
        tableData[i].eventuser = total[i].value; // table的eventuser column赋值
        // table的rate column赋值
        tableData[i].rate = i === 0 ? '' : `${currentRate === 'N/A' ? '0.00' : currentRate}`;
      }
      // 把setData赋值给chartData的series属性
      chartData.series = [
        {
          type: 'bar',
          label: {
            normal: {
              show: true,
              position: 'top',
              offset: [0, -10],
              formatter(a) {
                return `${a.value}%`;
              },
              textStyle: {
                color: '#464c5b',
                fontSize: 14,
              },
            },
          },
          itemStyle: {
            normal: {
              color: '#43A3FB',
            },
          },
          barWidth: 50,
          data: setData,
        },
        {
          type: 'line',
          data: setData,
          lineStyle: {
            normal: {
              color: '#43A3FB',
            },
          },
        },
      ];
      this.drawTable(tableData); // 渲染表格table
      this.$refs.funnelchart.chartData = chartData;
      this.$refs.funnelchart.initChart(chartData);
    },
    // 获取图表，表格数据, 不再需要这个函数
    loopGetData(total, list, i, table, chart, seriesData) {
      // 表格数据 步骤名称，用户数，较上步率，总体转换率
      const chartData = chart;
      const setData = seriesData || [];
      const value = table;
      const idlist = [];
      for (let key = 0; key < list.length; key += 1) {
        if (key <= i) idlist.push(list[key]);
      }
      this.getData(idlist).then((res) => {
        const rate = percent((res[0].eventuser / total) * 100);
        setData[i] = rate === 'N/A' ? '0.00' : rate;
        value[i].eventuser = res[0].eventuser;
        value[i].rate = i === 0 ? '' : `${rate === 'N/A' ? '0.00' : rate}`;
        if (i + 1 < list.length) {
          this.loopGetData(total, list, i + 1, table, chartData, setData);
        } else if (i + 1 === list.length) {
          chartData.series = [
            {
              type: 'bar',
              label: {
                normal: {
                  show: true,
                  position: 'top',
                  offset: [0, -10],
                  formatter(a) {
                    return `${a.value}%`;
                  },
                  textStyle: {
                    color: '#464c5b',
                    fontSize: 14,
                  },
                },
              },
              itemStyle: {
                normal: {
                  color: '#43A3FB',
                },
              },
              barWidth: 50,
              data: setData,
            },
            {
              type: 'line',
              data: setData,
              lineStyle: {
                normal: {
                  color: '#43A3FB',
                },
              },
            },
          ];
          this.drawTable(table);
          this.$refs.funnelchart.chartData = chartData;
          this.$refs.funnelchart.initChart(chartData);
        }
      });
    },
    drawTable(data) {
      const table = data;
      for (let i = 0; i < table.length; i += 1) {
        if (table[i].name === undefined) {
          table.splice(i, 1);
          i -= 1;
        } else if (i === 0) {
          table[i].preRate = '';
        } else {
          const num = percent((table[i].eventuser / table[i - 1].eventuser) * 100);
          table[i].preRate = num === 'N/A' ? '0.00' : num;
        }
      }
      const save = JSON.stringify(table);
      const sort = JSON.parse(save);
      sort.sort((a, b) => a.preRate - b.preRate);
      if (sort.length > 1) {
        for (let i = 0; i < table.length; i += 1) {
          if (table[i].name === sort[1].name) {
            this.stepNumber = i + 1;
          }
        }
      } else {
        this.stepNumber = ln[bus.lang].funnel.stepNumber[0];
      }
      this.lowRate = sort[1] ? sort[1].name : sort[0].name;
      this.$refs.funnelchart.tableData = table;
      this.$refs.funnelchart.saveTableData = JSON.stringify(table);
    },
    // 渲染现有步骤的eventId, 作为post请求体的数据
    reloadId() {
      const items = bus.funnelChart.info.map(eachstep => ({
        eventId: eachstep.eventid,
        eventType: eachstep.eventtype,
      }));
      return items;
    },
    // 下载表格
    toExportTable() {
      const name = `${this.funnelName} ${this.$t('funnel.title')}`;
      this.$refs.funnelchart.exportTable(name);
    },
  },
};
</script>
